import font from './app/font'
import sounds from './app/sounds'
import svgs from './app/svgs'
import router from './app/router'
import setup from './app/setup'
import render from './app/render'

import * as view from './views/views'
import * as component from './components/components'
import * as data from './data/data'
import * as util from './util/util'

export default function(o){

  console.log('frontend ready')

  o.render = render
  o.router = router
  o.view = view
  o.component = component
  o.data = data
  o.util = util

  font(function(){
    console.log('fonts ready')

    sounds(o, function(){
      console.log('sounds ready')

      svgs(o, function(){
        console.log('svgs ready')

        router(o, function(){
          console.log('router ready')

          setup(o, function(){
            console.log('setup ready')

            o.log('start', navigator.userAgent)
            render(o)

          })
        })
      })
    })
  })
}



// WEBPACK FOOTER //
// ./src/client/view/frontend/frontend.js